import { http } from "@/http/http.js";
// 查询
export const searchList = (data) => {
  return http.post("/web/jd/list", data);
};

// 新增/修改
export const addOrEdit = (data) => {
  return http.post("/web/jd/save", data);
};

// 删除
export const delStreet = (data) => {
  return http.post("/web/jd/delete", data);
};

// 详情
export const detail = (data) => {
  return http.post("/web/jd/query", data);
};
